import Platform from '../react/Platform';
export function env(name, def = null) {
    return (window._env_ ?
        window._env_[name] :
        null)
        || def;
}
/**
 * Returns whether or not the current environment is a mobile device.
 *
 * @returns {boolean}
 */
export function isMobileBrowser() {
    return Platform.OS === 'android' || Platform.OS === 'ios';
}
/**
 * Returns whether or not the current environment is an ios mobile device.
 *
 * @returns {boolean}
 */
export function isIosMobileBrowser() {
    return Platform.OS === 'ios';
}
/**
 * Returns whether or not the current environment is an ipad device.
 *
 * @returns {boolean}
 */
export function isIpadMobileBrowser() {
    // @ts-ignore
    return isIosMobileBrowser() && Platform.isPad;
}
